// dependencies
import React from "react";
import { useIntl } from "react-intl";

import withMedia from "../../hocs/withMedia";

// components
import { Row, Col } from "../Grid";
import PreciseRate from "./PreciseRate";

// utils
import compose from "@cloudspire/legacy-shared/src/libraries/utils/compose";

type IProps = {
  matches?: boolean;
  cosinessRate: number;
  fairnessRate: number;
  greetingRate: number;
  qualityRate: number;
};

const RateList: React.FunctionComponent<IProps> = (props) => {
  const { cosinessRate, fairnessRate, greetingRate, qualityRate, matches } =
    props;

  const intl = useIntl();

  return (
    <Row
      breakpointList={{ all: Infinity }}
      col={{ all: matches ? 4 : 1 }}
      gutter={matches ? 0.625 : 0.125}
    >
      <Col>
        <PreciseRate
          matches={matches}
          rate={fairnessRate}
          label={intl.formatMessage({
            defaultMessage: "Propreté",
          })}
        />
      </Col>
      <Col>
        <PreciseRate
          matches={matches}
          rate={greetingRate}
          label={intl.formatMessage({
            defaultMessage: "Accueil",
          })}
        />
      </Col>
      <Col>
        <PreciseRate
          matches={matches}
          rate={cosinessRate}
          label={intl.formatMessage({
            defaultMessage: "Confort",
          })}
        />
      </Col>
      <Col>
        <PreciseRate
          matches={matches}
          rate={qualityRate}
          label={intl.formatMessage({
            defaultMessage: "Qualité / Prix",
          })}
        />
      </Col>
    </Row>
  );
};

export default compose(
  withMedia({ query: { minWidth: 490 }, breakpointType: "element" })
)(RateList);
